import { BaseContainerModel } from "../base-container.model";
import { bl_wms_warehouse_layout_node_container_link_RowInterface, bl_wms_warehouse_layout_node_container_link_RowClass } from "../../dbschema/index";

export class WarehouseLayoutNodeContainerLinkModel extends BaseContainerModel {
    bl_wms_warehouse_layout_node_container_link: bl_wms_warehouse_layout_node_container_link_RowInterface = new bl_wms_warehouse_layout_node_container_link_RowClass();
}
